import React from 'react';

export default function BotDemoLogin({ setIsLoggedIn }) {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');

  const validUsername = 'admin';
  const validPassword = 'test12345';

  const handleLogin = () => {
    if (username === validUsername && password === validPassword) {
      setIsLoggedIn(true);
    } else {
      alert('Invalid credentials, please try again.');
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#dc143c',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        padding: '2rem',
        borderRadius: '15px',
        boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
        maxWidth: '350px',
        width: '100%',
        textAlign: 'center'
      }}>
        <img
          src="https://www.atrobot.asia/logo.jpg"
          alt="bot-logo"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '12px',
            marginBottom: '1rem'
          }}
        />
        <h2 style={{
          marginBottom: '1.5rem',
          color: '#333'
        }}>
          Astra @ ATROBOT
        </h2>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{
            padding: '0.7rem',
            marginBottom: '1rem',
            width: '90%',
            borderRadius: '8px',
            border: '1px solid #ddd',
            fontSize: '14px'
          }}
        />
        
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            padding: '0.7rem',
            marginBottom: '1.5rem',
            width: '90%',
            borderRadius: '8px',
            border: '1px solid #ddd',
            fontSize: '14px'
          }}
        />

        <button
          onClick={handleLogin}
          style={{
            padding: '0.8rem',
            width: '95%',
            backgroundColor: '#dc143c',
            color: '#fff',
            fontSize: '16px',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bf2419'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#dc143c'}
        >
          Login
        </button>
      </div>
    </div>
  );
}
